import {
  Toggle,
  Label,
} from "@tandemdiabetes/sugarmate-react-components"
import dayjs from "dayjs"
import type { ChangeEventHandler } from "react"
import { useCallback } from "react"
import styles from "./PrivacyAndDataUse.module.scss"
import {
  PageTemplate,
  PolicyViewerLink,
} from "src/components"
import { usePolyglot } from "src/contexts"
import {
  useTrackingTechnologyConsentDocument,
  useTrackingTechnologyConsent,
} from "src/hooks"
import { NotFound } from "src/pages/NotFound"
import {
  getDeviceRegion,
  isUS,
} from "src/utils"

// note we are checking device region not account region
const isUSDevice = isUS(getDeviceRegion())

const polyglotPrefix = "pages.help_and_feedback.privacy_and_data_use."
const id = "tracking-technology-consent-toggle"

export function PrivacyAndDataUse() {
  const polyglot = usePolyglot()

  const { data: trackingTechnologyConsentDocument } = useTrackingTechnologyConsentDocument()

  const [
    response,
    setResponse,
  ] = useTrackingTechnologyConsent()

  const onChange: ChangeEventHandler<HTMLInputElement> = useCallback(
    (e) => {
      setResponse({
        value: e.target.checked ? "accepted" : "rejected",
        updatedAt: dayjs().toISOString(),
      })
    },
    [setResponse],
  )

  if (isUSDevice) {
    return <NotFound />
  }

  return (
    <PageTemplate
      user="account"
      title={polyglot.t("components.page_header.pages.privacy_and_data_use")}
      backRoutePath={"/help_and_feedback"}
    >
      <div className={styles.container}>
        <div className={styles.toggleContainer}>
          <div className={styles.toggleRow}>
            <Label htmlFor={id}>
              {polyglot.t(`${polyglotPrefix}label`)}
            </Label>
            <Toggle
              id={id}
              onChange={onChange}
              checked={response?.value === "accepted"}
            />
          </div>
          <div className={styles.description}>
            {polyglot.t(
              `${polyglotPrefix}description`,
              {
                link: (
                  <PolicyViewerLink
                    policyDocument={trackingTechnologyConsentDocument}
                    policyDocumentName="tracking-technology"
                  >
                    {polyglot.t(`${polyglotPrefix}link_text`)}
                  </PolicyViewerLink>
                ),
              },
            )}
          </div>
        </div>
      </div>
    </PageTemplate>
  )
}
